import _, { isObject } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import {
    MTTriggersPageListName,
    myTasks5WayDependListName,
    myTasksDepartmentsListName,
    myTasksDeviationReportDependListName,
    myTasksDeviationReportKpiByTriggerListName,
    myTasksDeviationReportTriggersListName,
    myTasksKpiByTriggerListName,
    myTasksKPIListName,
    myTasksLocationsListName,
    myTasksRegionsListName,
    myTasksTriggersListName,
} from "src/api/config/myTasksLists.config";
import Form from "src/components/Form";
import Loading from "src/components/Loading";
import { useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { selectItems } from "src/modules/spItems/selectors";
import { selectCurrentUser } from "src/modules/users/selector";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import LoadingOpBg from "src/components/LoadingOpBg";
import {
    FiveWhyType
} from "src/api/config/systemSwitch";
import { FavoriteButtonFilters } from "src/modules/favoriteFilters/mt/FavoriteButtonFilters";
import { FavoriteFiltersList } from "src/modules/favoriteFilters/mt/FavoriteFiltersList";
import SettingsIcon from "src/components/ui-icons/buttons/Settings";
import Button from "src/components/Button";
import { Modal } from "src/components/DialogComponent";
import { exportExcelFile } from "src/modules/exelExport/exelExport";
import { EmptyList } from "src/components/EmptyList";
import MyTasksTriggersTable from "src/components/tables/MyTasksTriggersTable";
import AddTrigger from "../addTrigger/addTrigger";
import TGButton from "src/components/ui/TGButton";
import { useNavigate } from "react-router-dom";
import { paramsListName } from "src/api/config";

function TriggersFilters({
    setFilters,
    setGetListTriggers,
    type,
    setDisplayFilters,
    filtersParams,
    setFiltersParams,
    defaultUserFilter,
    userFilterCheck,
    reRenderUserFilter,
    setLocalFilters
}: any) {
    const [defaultValues, setDefaultValues] = useState({});
    const [fields, setFields] = useState<any>([
        {
            type: "radio",
            require: false,
            key: "Status",
            searchInFilterCheckbox: false,
            isFilter: true,
            title: "Статус",
            placeholder: "Не выбрано",
            width: "w-full",
            optionsInputs: ["Активный", "В архиве"],
        },
        {
            type: "checkbox",
            require: false,
            key: "Location",
            isFilter: true,
            searchInFilterCheckbox: true,
            title: "Локация",
            width: "w-full",
        },
        {
            type: "checkbox",
            require: false,
            key: "Department",
            searchInFilterCheckbox: true,
            isFilter: true,
            title: "Отдел",
            width: "w-full",
        },
        {
            type: "checkbox",
            require: false,
            key: "Region",
            searchInFilterCheckbox: true,
            title: "Участок",
            isFilter: true,
            placeholder: "Не выбрано",
            width: "w-full",
        },
        {
            type: "checkbox",
            require: false,
            key: "Trigger",
            searchInFilterCheckbox: true,
            isFilter: true,
            title: "Триггер",
            placeholder: "Не выбрано",
            width: "w-full",
        },
        {
            type: "checkbox",
            require: false,
            key: "KPI",
            searchInFilterCheckbox: true,
            title: "KPI",
            isFilter: true,
            placeholder: "Не выбрано",
            width: "w-full",
        }
    ]);
    const [triggersFilter, setTriggersFilter] = useState<any>(null);

    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null,
        Trigger: null,
        KPI: null,
    });

    const currentUser = useAppSelector((state) => selectCurrentUser(state));

    const locations: any = useAppSelector((state) =>
        selectItems(state, myTasksLocationsListName)
    );
    const departments: any = useAppSelector((state) =>
        selectItems(state, myTasksDepartmentsListName)
    );
    const regions: any = useAppSelector((state) =>
        selectItems(state, myTasksRegionsListName)
    );
    const triggers: any = useAppSelector((state) =>
        selectItems(state, myTasksTriggersListName)
    );
    const triggersDeviationReport: any = useAppSelector((state) =>
        selectItems(state, myTasksDeviationReportTriggersListName)
    );
    const kpiItems: any = useAppSelector((state) =>
        selectItems(state, myTasksKPIListName)
    );

    const [customLoading, setCustomLoading] = useState(true);
    const [resetFilters, setResetFiters] = useState(false);
    const [isDefaultDepartment, setDefaultDepartment] = useState(0);

    //Формируем данные фильтры по умолчанию
    useEffect(() => {
        setCustomLoading(true);
        const tempFieldsForm = [...fields];
        let tempTriggers: any = [];
        if (type === FiveWhyType) {
            tempTriggers = [...triggers];
        } else {
            tempTriggers = [...triggersDeviationReport];
        }
        for (let i = 0; i < tempFieldsForm.length; i++) {
            if (tempFieldsForm[i]["key"] === "Location") {
                tempFieldsForm[i]["optionsInputs"] = locations.map((location: any) => {
                    return {
                        id: location.ID,
                        name: location.Title,
                        disabled: false,
                    };
                });
            }
            if (tempFieldsForm[i]["key"] === "Department") {
                tempFieldsForm[i]["optionsInputs"] = departments.map(
                    (department: any) => {
                        return {
                            id: department.ID,
                            name: department.Title,
                            disabled: false,
                        };
                    }
                );
            }
            if (tempFieldsForm[i]["key"] === "Region") {
                tempFieldsForm[i]["optionsInputs"] = regions.map((region: any) => {
                    return {
                        id: region.ID,
                        name: region.Title,
                        disabled: false,
                    };
                });
            }
            if (tempFieldsForm[i]["key"] === "Trigger") {
                tempFieldsForm[i]["optionsInputs"] = tempTriggers.map(
                    (trigger: any) => {
                        return {
                            id: trigger.ID,
                            name: trigger.Title,
                            disabled: false,
                        };
                    }
                );
            }
            if (tempFieldsForm[i]["key"] === "KPI") {
                tempFieldsForm[i]["optionsInputs"] = kpiItems.map((kpiItem: any) => {
                    return {
                        id: kpiItem.ID,
                        name: kpiItem.Title,
                        disabled: false,
                    };
                });
            }
        }
        setFields([...tempFieldsForm]);
        setCustomLoading(false);
    }, [
        locations,
        departments,
        regions,
        triggers,
        kpiItems,
        triggersDeviationReport,
        type,
    ]);

    useEffect(() => {
        if (Object.keys(currentUser).length > 0 && currentUser.id > 0 && (triggers.length > 0 || triggersDeviationReport.length > 0)) {
            setCustomLoading(true);
            let filtersDepend5Way: any = {};
            let filtersDependKpi: any = {};
            const tempFieldsForm = [...fields];
            let tempTriggers: any = [];
            if (type === FiveWhyType) {
                tempTriggers = [...triggers];
            } else {
                tempTriggers = [...triggersDeviationReport];
            }
            Object.keys(dependenceFields).map((key) => {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === key) {
                        tempFieldsForm[i]["optionsInputs"] = tempFieldsForm[i][
                            "optionsInputs"
                        ].map((option: any) => {
                            return {
                                id: option.id,
                                name: option.name,
                                disabled: false,
                            };
                        });
                    }
                }
            });
            Object.keys(dependenceFields).map((key) => {
                if (
                    dependenceFields[key] &&
                    dependenceFields[key].length > 0 &&
                    key !== "KPI"
                ) {
                    if (key === "Department") {
                        filtersDepend5Way["Departament"] = dependenceFields[key].map(
                            (item: any) => item.id
                        );
                    } else {
                        filtersDepend5Way[key] = dependenceFields[key].map(
                            (item: any) => item.id
                        );
                    }
                } else if (
                    key === "KPI" &&
                    dependenceFields[key] &&
                    dependenceFields[key].length > 0
                ) {
                    filtersDependKpi["Kpi"] = dependenceFields[key].map(
                        (item: any) => item.id
                    );
                }
            });
            if (
                Object.keys(filtersDependKpi).length === 0 &&
                Object.keys(filtersDepend5Way).length === 0
            ) {
                setFields([...tempFieldsForm]);
                setCustomLoading(false);
            } else {
                if (
                    Object.keys(filtersDependKpi).length > 0 &&
                    Object.keys(filtersDepend5Way).length === 0
                ) {
                    getItemsRequest({
                        listName:
                            (type === FiveWhyType && myTasksKpiByTriggerListName) ||
                            myTasksDeviationReportKpiByTriggerListName,
                        filters: filtersDependKpi,
                        method: type === FiveWhyType && '/api/kpi-by-triggers/search' || '/api/deviation-report-kpi-by-triggers/search'
                    }).then((results) => {
                        const dependKpiByTrigger = [...results.items];
                        const triggerIds = _.uniqWith(
                            dependKpiByTrigger
                                .filter((item: any) => item.Trigger)
                                .map((item: any) => item.Trigger.get_lookupId()),
                            _.isEqual
                        );
                        for (let i = 0; i < tempFieldsForm.length; i++) {
                            if (tempFieldsForm[i]["key"] === "Trigger") {
                                tempFieldsForm[i]["optionsInputs"] = tempTriggers.map(
                                    (trigger: any) => {
                                        return {
                                            id: trigger.ID,
                                            name: trigger.Title,
                                            disabled: false, //triggerIds.indexOf(trigger.ID) === -1,
                                            hide: triggerIds.indexOf(trigger.ID) === -1
                                        };
                                    }
                                );
                            }
                        }
                        setFields([...tempFieldsForm]);
                        setCustomLoading(false);
                    });
                }
                if (Object.keys(filtersDepend5Way).length > 0) {
                    //Устанавливаем зависимости в фильтрах
                    getItemsRequest({
                        listName:
                            (type === FiveWhyType && myTasks5WayDependListName) ||
                            myTasksDeviationReportDependListName,
                        filters: filtersDepend5Way,
                        filtersType: "or",
                    }).then((results) => {
                        const depend5Way = [...results.items];
                        const locationIds = _.uniqWith(
                            depend5Way.map((item: any) => item.Location.get_lookupId()),
                            _.isEqual
                        );
                        const departmentIds = _.uniqWith(
                            depend5Way.map((item: any) => item.Departament.get_lookupId()),
                            _.isEqual
                        );
                        const regionIds = _.uniqWith(
                            depend5Way.map((item: any) => item.Region.get_lookupId()),
                            _.isEqual
                        );
                        const triggerIds = _.uniqWith(
                            depend5Way
                                .filter((item: any) => item.Trigger)
                                .map((item: any) => item.Trigger.get_lookupId()),
                            _.isEqual
                        );
                        for (let i = 0; i < tempFieldsForm.length; i++) {
                            if (tempFieldsForm[i]["key"] === "Location") {
                                if (
                                    !filtersDepend5Way["Location"] ||
                                    Object.keys(filtersDepend5Way).length > 1
                                ) {
                                    tempFieldsForm[i]["optionsInputs"] = locations.map(
                                        (location: any) => {
                                            return {
                                                id: location.ID,
                                                name: location.Title,
                                                disabled: false, //locationIds.indexOf(location.ID) === -1,
                                                hide: locationIds.indexOf(location.ID) === -1,
                                            };
                                        }
                                    );
                                }
                            }
                            if (tempFieldsForm[i]["key"] === "Department") {
                                if (
                                    !filtersDepend5Way["Departament"] ||
                                    Object.keys(filtersDepend5Way).length > 1
                                ) {
                                    tempFieldsForm[i]["optionsInputs"] = departments.map(
                                        (department: any) => {
                                            return {
                                                id: department.ID,
                                                name: department.Title,
                                                disabled: false, //departmentIds.indexOf(department.ID) === -1,
                                                hide: departmentIds.indexOf(department.ID) === -1,
                                                user_Department: department.User_Department
                                            };
                                        }
                                    );
                                    tempFieldsForm[i]["optionsInputs"].forEach((department: any) => {
                                        if (department.user_Department && department.user_Department.indexOf(currentUser.department) !== -1 && department.disabled) {
                                            setDefaultDepartment(department.id);
                                        }
                                    });
                                }
                            }
                            if (tempFieldsForm[i]["key"] === "Region") {
                                if (
                                    !filtersDepend5Way["Region"] ||
                                    Object.keys(filtersDepend5Way).length > 1
                                ) {
                                    tempFieldsForm[i]["optionsInputs"] = regions.map(
                                        (region: any) => {
                                            return {
                                                id: region.ID,
                                                name: region.Title,
                                                disabled: false, //regionIds.indexOf(region.ID) === -1,
                                                hide: regionIds.indexOf(region.ID) === -1,
                                            };
                                        }
                                    );
                                }
                            }
                            if (tempFieldsForm[i]["key"] === "Trigger") {
                                if (
                                    !filtersDepend5Way["Trigger"] ||
                                    Object.keys(filtersDepend5Way).length > 1
                                ) {
                                    tempFieldsForm[i]["optionsInputs"] = tempTriggers.map(
                                        (trigger: any) => {
                                            return {
                                                id: trigger.ID,
                                                name: trigger.Title,
                                                disabled: false, //triggerIds.indexOf(trigger.ID) === -1,
                                                hide: triggerIds.indexOf(trigger.ID) === -1,
                                            };
                                        }
                                    );
                                }
                            }
                        }
                        if (triggerIds.length > 0) {
                            getItemsRequest({
                                listName:
                                    (type === FiveWhyType && myTasksKpiByTriggerListName) ||
                                    myTasksDeviationReportKpiByTriggerListName,
                                filters: { Trigger: triggerIds },
                                method: type === FiveWhyType && '/api/kpi-by-triggers/search' || '/api/deviation-report-kpi-by-triggers/search'
                            }).then((results) => {
                                const dependKpiByTrigger = [...results.items];
                                const kpiIds = _.uniqWith(
                                    dependKpiByTrigger.map((item: any) => item.Kpi.get_lookupId()),
                                    _.isEqual
                                );
                                for (let i = 0; i < tempFieldsForm.length; i++) {
                                    if (tempFieldsForm[i]["key"] === "KPI") {
                                        tempFieldsForm[i]["optionsInputs"] = kpiItems.map(
                                            (kpiItem: any) => {
                                                return {
                                                    id: kpiItem.ID,
                                                    name: kpiItem.Title,
                                                    disabled: false, //kpiIds.indexOf(kpiItem.ID) === -1,
                                                    hide: kpiIds.indexOf(kpiItem.ID) === -1,
                                                };
                                            }
                                        );
                                    }
                                }
                                setFields([...tempFieldsForm]);
                                setCustomLoading(false);
                            });
                        } else {
                            setFields([...tempFieldsForm]);
                            setCustomLoading(false);
                        }
                    });
                }
            }
        }
    }, [dependenceFields, currentUser, triggers, triggersDeviationReport]);

    useEffect(() => {
        if (locations.length > 0 && Object.keys(currentUser).length > 0 && currentUser.id > 0 && userFilterCheck && departments.length > 0) {
            let defaultObj: any = {};
            if (Object.keys(filtersParams).length > 0) {
                Object.keys(filtersParams).forEach(key => {
                    if (filtersParams[key]) {
                        defaultObj[key] = filtersParams[key];
                    } else {
                        defaultObj[key] = null;
                    }
                });
                setDefaultValues(defaultObj);
            } else if (defaultUserFilter && Object.keys(JSON.parse(defaultUserFilter.MTFullFilters)).length > 0) {
                Object.keys(JSON.parse(defaultUserFilter.MTFullFilters)).forEach(key => {
                    if (JSON.parse(defaultUserFilter.MTFullFilters)[key]) {
                        defaultObj[key] = JSON.parse(defaultUserFilter.MTFullFilters)[key];
                    } else {
                        defaultObj[key] = null;
                    }
                });
                setDefaultValues(defaultObj);
            } else {
                let defaultLocationsIds: number[] = [];
                if (currentUser.isLocationAdminMyTasks || currentUser.isLocationEditorMyTasks) {
                    if (Array.isArray(currentUser.isLocationAdminMyTasks) && currentUser.isLocationAdminMyTasks.length > 0) {
                        defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationAdminMyTasks];
                    }
                    if (Array.isArray(currentUser.isLocationEditorMyTasks) && currentUser.isLocationEditorMyTasks.length > 0) {
                        defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationEditorMyTasks];
                    }
                }
                let unicDefaultLocationsIds: number[] = [..._.uniqWith(defaultLocationsIds, _.isEqual)];
                setDependenceFields({
                    Location: unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
                        return { id: id, name: locations.find((collection: any) => collection.ID === id)['Title'], disabled: false }
                    }) || null,
                    Department: null,
                    Region: null,
                    Trigger: null,
                    KPI: null,
                });
                fields.map((field: any) => {
                    if (field.key === "Location") {
                        defaultObj[field.key] = unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
                            return { id: id, name: locations.find((collection: any) => collection.ID === id)['Title'], disabled: false }
                        }) || null;
                    } else if (field.key === "Department") {
                        defaultObj[field.key] = departments.filter((department: any) => currentUser.department && department.User_Department && department.User_Department.indexOf(currentUser.department) !== -1).map((department: any) => {
                            return { id: department.ID, name: department.Title, disabled: false }
                        }) || null;
                    } else if (field.key === "Status") {
                        defaultObj[field.key] = 'Активный'
                    } else {
                        defaultObj[field.key] = null;
                    }
                });
                setDefaultValues(defaultObj);
            }
        }
    }, [resetFilters, locations, JSON.stringify(currentUser), userFilterCheck, reRenderUserFilter, departments]);

    useEffect(() => {
        if (triggersFilter && Object.keys(triggersFilter).length > 0) {
            const existsFiltersTriggers: any = {};
            Object.keys(triggersFilter).map((key) => {
                if (triggersFilter[key]) {
                    if (Array.isArray(triggersFilter[key])) {
                        if (triggersFilter[key].length > 0) {
                            existsFiltersTriggers[key] = triggersFilter[key];
                        }
                    } else if (isObject(triggersFilter[key])) {
                        if (Object.keys(triggersFilter[key]).length > 0) {
                            existsFiltersTriggers[key] = triggersFilter[key];
                        }
                    } else {
                        existsFiltersTriggers[key] = triggersFilter[key];
                    }
                }
            });
            const tempFilters: any = {};
            const tempDisplayFilters: any = {};
            const tempLocalFilters: any = {};
            console.log("existsFiltersTriggers: ", existsFiltersTriggers);
            Object.keys(existsFiltersTriggers).map((key) => {
                if (
                    key === "Location" ||
                    key === "Department" ||
                    key === "Region" ||
                    key === "Status" ||
                    key === "Trigger" ||
                    key === "KPI"
                ) {
                    if (key === 'Status') {
                        if (existsFiltersTriggers[key] === 'В архиве') {
                            tempFilters['Hide'] = true;
                        } else if (existsFiltersTriggers[key] === 'Активный') {
                            tempFilters['Hide'] = [false, null];
                        }
                    } else if (key === 'Region') {
                        tempFilters['Area'] = existsFiltersTriggers[key].map((item: any) => item.id);
                    } else if (key === 'KPI') {
                        tempLocalFilters['Kpi'] = existsFiltersTriggers[key].map((item: any) => item.id);
                    } else {
                        tempFilters[key] = existsFiltersTriggers[key].map((item: any) => item.id);
                    }
                    tempDisplayFilters[key] = Array.isArray(existsFiltersTriggers[key]) && existsFiltersTriggers[key].map((item: any) => item.name) || existsFiltersTriggers[key];
                }
            });
            setLocalFilters({ ...tempLocalFilters });
            setFilters({ ...tempFilters });
            setDisplayFilters({ ...tempDisplayFilters });

            if (JSON.stringify(filtersParams) !== JSON.stringify(existsFiltersTriggers)) {
                setFiltersParams({ ...existsFiltersTriggers });
            }
            setGetListTriggers(false);
        }
    }, [triggersFilter]);

    useEffect(() => {
        console.log('isDefaultDepartment: ', isDefaultDepartment);
        if (isDefaultDepartment) {
            setDefaultValues((prevState) => {
                return { ...prevState, Department: null }
            });
        }
    }, [isDefaultDepartment]);

    return (
        <FlexCol className="relative filters-date-no-remove">
            {customLoading && <LoadingOpBg />}
            {triggersFilter && Object.keys(triggersFilter).length > 0 && (
                <div
                    onClick={() => {
                        setTriggersFilter(null);
                        setDisplayFilters({});
                        setFiltersParams({});
                        setResetFiters(!resetFilters);
                        setGetListTriggers(false);
                    }}
                    className="p-5 flex flex-row group items-center text-[14px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap border-b"
                >
                    <div className="flex flex-col">Сбросить фильтры</div>
                    <div className="flex flex-col pt-1">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_33_4954)">
                                <path
                                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                                    fill="#637381"
                                ></path>
                            </g>
                            <defs>
                                <clipPath id="clip0_33_4954">
                                    <rect
                                        width="16"
                                        height="16"
                                        fill="white"
                                        transform="translate(0 12) rotate(-90)"
                                    ></rect>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            )}
            <Form
                type="list5way_filters_my_tasks"
                setFormData={setTriggersFilter}
                fieldsForm={fields}
                defaultValues={defaultValues}
                setDependenceFields={setDependenceFields}
            />
            {triggersFilter && Object.keys(triggersFilter).length > 0 && (
                <div
                    onClick={() => {
                        setTriggersFilter(null);
                        setDisplayFilters({});
                        setFiltersParams({});
                        setResetFiters(!resetFilters);
                        setGetListTriggers(false);
                    }}
                    className="p-5 flex flex-row group items-center text-[12px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap"
                >
                    <div className="flex flex-col group-hover:underline">
                        Сбросить фильтры
                    </div>
                    <div className="flex flex-col pt-1">
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_33_4954)">
                                <path
                                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                                    fill="#637381"
                                ></path>
                            </g>
                            <defs>
                                <clipPath id="clip0_33_4954">
                                    <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0 12) rotate(-90)"
                                    ></rect>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            )}
        </FlexCol>
    );
}

export function Triggers({ type }: { type: string }) {
    const [filters, setFilters] = useState<any>({});
    const [localFilters, setLocalFilters] = useState<any>({});
    const [nextPage, setNextPage] = useState<any>(null);
    const [listTriggers, setListTriggers] = useState<any>([]);
    const [tempListTriggers, setTempListTriggers] = useState<any>([]);
    const [customLoading, setCustomLoading] = useState(true);
    const [getListTriggers, setGetListTriggers] = useState(false);
    const currentUser = useAppSelector((state) => selectCurrentUser(state));
    const [scrollDown, setScrollDown] = useState(false);
    const [displayFilters, setDisplayFilters] = useState<any>({});
    const [displayFiltersStr, setDisplayFiltersStr] = useState<any>("");
    const [reRenderFilterSettings, setReRenderFilterSettings] = useState(false);
    const [filtersParams, setFiltersParams] = useState({});
    const [defaultUserFilter, setDefaultUserFilter] = useState<any>(null);
    const [userFilterCheck, setUserFilterCheck] = useState(false);
    const [reRenderUserFilter, setReRenderUserFilter] = useState(null);
    const [openImportExel, setOpenImportExel] = useState(false);
    const [allLoading, setAllLoading] = useState(false);
    const [blockPage, setBlockPage] = useState(false);
    const navigate = useNavigate();
    const notice: any = useAppSelector((state) =>
        selectItems(state, paramsListName)
    );

    const [tableHeaderContentExel, setTableHeaderContentExel] = useState<any>({
        Created: {
            title: "Дата создания",
            width: 50,
        },
        Location: {
            title: "Локация",
            width: 50,
        },
        Departament: {
            title: "Отдел",
            width: 50,
        },
        Region: {
            title: "Участок",
            width: 50,
        },
        Trigger: {
            title: "Триггер",
            width: 50,
        },
        Kpi: {
            title: "KPI",
            width: 50,
        },
        AuthorEmail: {
            title: "Создатель",
            width: 50,
        },
        Status: {
            title: "Статус",
            width: 50,
        }
    });

    useEffect(() => {
        const controller = new AbortController();
        if (!getListTriggers && Object.keys(filters).length > 0) {
            const clearCache = moment().unix();
            setCustomLoading(true);
            setCustomLoading(true);
            setListTriggers([]);
            setTempListTriggers([]);
            getItemsRequest({
                listName: MTTriggersPageListName,
                rowLimit: 100,
                filters,
                sortOrder: { name: "ID", desc: true },
                signal: controller.signal,
                otherParams: { type, clearCache }
            }).then((results: any) => {
                const { items, nextPage } = results;
                setNextPage(nextPage);
                setTempListTriggers([...items]);
                setGetListTriggers(true);
                setCustomLoading(false);
            });
        }
        return () => controller.abort();
    }, [filters, getListTriggers]);

    //Получение триггеров по nextPage
    useEffect(() => {
        if (nextPage && getListTriggers && scrollDown) {
            const clearCache = moment().unix();
            setCustomLoading(true);
            getItemsRequest({
                listName: MTTriggersPageListName,
                rowLimit: 100,
                filters,
                nextPage,
                sortOrder: { name: "ID", desc: true },
                otherParams: { type, clearCache }
            }).then((results: any) => {
                const { items, nextPage } = results;
                setTempListTriggers((prevState: any) => [...prevState, ...items]);
                setCustomLoading(false);
                setNextPage(nextPage);
                setScrollDown(false);
            });
        }
    }, [nextPage, scrollDown]);

    useEffect(() => {
        let tempStr = "";
        Object.keys(displayFilters).map((key: string, idx: number) => {
            if (idx <= 3) {
                if (Array.isArray(displayFilters[key])) {
                    displayFilters[key].map((item: string, idx: number) => {
                        if (displayFilters[key].length - 1 === idx) {
                            tempStr += item
                        } else {
                            tempStr += `${item}, `
                        }
                    })
                } else {
                    tempStr += `${displayFilters[key]}`
                }
                tempStr += ', '
            }
        });
        tempStr = tempStr.slice(0, -2);
        if (Object.keys(displayFilters).length > 4) {
            tempStr += `...ещё ${Object.keys(displayFilters).length - 4}`
        }
        setDisplayFiltersStr(tempStr);
    }, [displayFilters]);

    useEffect(() => {
        if (Object.keys(localFilters).length > 0) {
            setListTriggers(tempListTriggers.filter((item: any) => localFilters.Kpi.includes(item.Kpi?.get_lookupId())));
        } else {
            setListTriggers([...tempListTriggers]);
        }
    }, [tempListTriggers]);

    useEffect(() => {
        if (openImportExel) {
            setAllLoading(true);
            async function fetchData() {
                const importFilter = { ...filters };
                const results = await getItemsRequest({
                    listName: MTTriggersPageListName,
                    rowLimit: 1000000,
                    filters: importFilter,
                    sortOrder: { name: "ID", desc: true },
                    otherParams: { type }
                });
                const { items } = results;
                if (items.length > 0) {
                    let exportColumns: any = [];
                    Object.keys(tableHeaderContentExel).map((key: any) => {
                        exportColumns = [
                            ...exportColumns,
                            {
                                header: tableHeaderContentExel[key]["title"],
                                key: key,
                                width: tableHeaderContentExel[key]["width"],
                            },
                        ];
                    });
                    let exportTemp: any = [];
                    items.forEach((item: any) => {
                        let color = "FF0000";
                        exportTemp = [
                            ...exportTemp,
                            {
                                Created: moment(item.Created).format("DD.MM.YYYY"),
                                Location: item.Location.get_lookupValue(),
                                Departament: item.Departament.get_lookupValue(),
                                Region: item.Region.get_lookupValue(),
                                Trigger: item.Trigger.get_lookupValue(),
                                Kpi: item.Kpi && item.Kpi.get_lookupValue() || '-',
                                AuthorEmail: item.AuthorEmail || '-',
                                Status: {
                                    richText: [
                                        {
                                            font: { size: 16, color: { argb: `${color}` }, name: "Calibri", family: 2, scheme: "minor" },
                                            text: item.Status,
                                        },
                                    ],
                                }
                            },
                        ];
                    });
                    const exportData = { columns: [...exportColumns], data: [...exportTemp] };
                    const fileName = "TriggersReport";
                    const type = "report_documents";
                    setAllLoading(false);
                    exportExcelFile(exportData, fileName, type, setOpenImportExel);
                    setOpenImportExel(false);
                } else {
                    setAllLoading(false);
                    setOpenImportExel(false);
                }
            }
            fetchData();
        }
    }, [openImportExel]);

    useEffect(() => {
        if (currentUser && Object.keys(currentUser).length > 0 && currentUser.id > 0 && (!currentUser.isAdmin && !currentUser.isFactoryAdmin)) {
            setBlockPage(true);
        }
    }, [currentUser]);

    return (
        <FlexRow className="scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-screen overflow-y-auto">
            {!blockPage &&
                <>
                    <FlexCol className="bg-white sticky-custom border-r w-80 text-[14px] text-[#8899A8] relative scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] max-h-screen">
                        <FlexCol className="max-w-[320px] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
                            <TriggersFilters
                                setGetListTriggers={setGetListTriggers}
                                setFilters={setFilters}
                                type={type}
                                setDisplayFilters={setDisplayFilters}
                                filtersParams={filtersParams}
                                setFiltersParams={setFiltersParams}
                                defaultUserFilter={defaultUserFilter}
                                userFilterCheck={userFilterCheck}
                                reRenderUserFilter={reRenderUserFilter}
                                setLocalFilters={setLocalFilters}
                            />
                        </FlexCol>
                    </FlexCol>
                    <FlexCol className="grow w-[calc(100%-320px)]">
                        <FlexCol className="w-full">
                            <FlexRow className="px-7.5 h-[76px] border-b justify-between items-center shrink-0">
                                <FlexCol>
                                    <nav
                                        className="flex justify-between w-full"
                                        aria-label="Breadcrumb"
                                    >
                                        <FlexCol className="grow">
                                            <ol className="inline-flex items-center">
                                                <li
                                                    className="inline-flex items-center"
                                                    aria-current="page"
                                                >
                                                    {(type === FiveWhyType && (
                                                        <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                                                            <SettingsIcon />
                                                            <span>Триггеры (5Почему)</span>
                                                        </div>
                                                    )) || (
                                                            <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                                                                <SettingsIcon />
                                                                <span>Триггеры (Отчеты об отклонениях)</span>
                                                            </div>
                                                        )}
                                                </li>
                                            </ol>
                                        </FlexCol>
                                    </nav>
                                </FlexCol>
                                <FlexRow className="px-7.5 py-5 justify-center gap-5">
                                    <Button
                                        classBg="btn-white min-w-[200px]"
                                        shadow={true}
                                        typeIcon="download"
                                        icon={true}
                                        text="Скачать в Excel"
                                        open={openImportExel}
                                        setOpen={setOpenImportExel}
                                    />
                                    <FlexCol className="items-center justify-center">
                                        {(currentUser.isLocationEditorMyTasks ||
                                            currentUser.isAdmin ||
                                            currentUser.isLocationAdminMyTasks) && (
                                                customLoading && <Loading /> || <AddTrigger zIndex={70} type={type} setRerenderTable={setGetListTriggers} />
                                            )}
                                    </FlexCol>
                                    <FlexRow className="items-center gap-2">
                                        <FavoriteButtonFilters filters={Object.keys(filters).length > 0 && JSON.stringify(filters) || ""} displayFilters={Object.keys(displayFilters).length > 0 && JSON.stringify(displayFilters) || ""} reRenderFilterSettings={reRenderFilterSettings} setReRenderFilterSettings={setReRenderFilterSettings} filtersParams={Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams) || ""} type='triggers' />
                                        <FavoriteFiltersList reRenderTableFlag={setGetListTriggers} reRenderFilterSettings={reRenderFilterSettings} setReRenderFilterSettings={setReRenderFilterSettings} setFiltersParams={setFiltersParams} type='triggers' filtersParams={Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams) || ""} listQuestions='triggersFavoriteList' setDefaultUserFilter={setDefaultUserFilter} setUserFilterCheck={setUserFilterCheck} userFilterCheck={userFilterCheck} setReRenderUserFilter={setReRenderUserFilter} />
                                    </FlexRow>
                                </FlexRow>
                            </FlexRow>
                            {notice.length > 0 &&
                                <p style={{ whiteSpace: "pre-wrap" }} className="mx-7.5 mt-5 px-7.5 py-5 text-black bg-white rounded-lg" dangerouslySetInnerHTML={{
                                    __html: type === FiveWhyType && notice
                                        .find(
                                            (param: any) => param.Key === "TriggerFiveWhyNotice"
                                        )
                                    ["Comments"].trim().replace(/\n/g, "<br />") || notice
                                        .find(
                                            (param: any) => param.Key === "TriggerDeviationReportNotice"
                                        )
                                    ["Comments"].trim().replace(/\n/g, "<br />")
                                }} />
                            }
                            <FlexCol className="px-7.5">
                                <MyTasksTriggersTable
                                    type={type}
                                    data={listTriggers}
                                    setScrollDown={setScrollDown}
                                    filters={filters}
                                    setRerenderTable={setGetListTriggers}
                                />
                                {!customLoading && listTriggers.length === 0 &&
                                    <FlexCol className="w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)]">
                                        <EmptyList title="Данные не найдены" />
                                    </FlexCol>
                                }
                                {!customLoading && listTriggers.length > 0 && <div className="w-full my-2 py-2 text-center bg-[#012169] text-white">Список сформирован</div>}
                                {customLoading && <div className="w-full my-2 py-2 text-center animate-pulse">Формируется список, пожалуйста подождите</div>}
                            </FlexCol>
                            <Modal zIndex={120} open={openImportExel} toggleDialog={setOpenImportExel} modalClassName="min-h-px">
                                {allLoading &&
                                    <FlexCol className="items-center justify-center mt-3 gap-5">
                                        <Loading />
                                        <span>Готовим файл для скачивания <br />Пожалуйста подождите...</span>
                                    </FlexCol>
                                }
                            </Modal>
                        </FlexCol>
                    </FlexCol>
                </>
            }
            <Modal hideXMarkIcon={true} zIndex={120} open={blockPage} toggleDialog={setBlockPage} modalClassName="min-h-px">
                <header className="px-10 pb-4 text-black">
                    <h1>Ошибка прав доступа</h1>
                </header>
                <div className="px-10 py-5 text-black grow">
                    <div>У Вас нет прав к этой странице</div>
                </div>
                <footer className="flex justify-center px-10 pt-10 mt-4 border-t">
                    <TGButton
                        color="bluedark"
                        onClick={() => {
                            navigate("/dashboard/3");
                        }}
                    >
                        Вернуться на главную
                    </TGButton>
                </footer>
            </Modal>
        </FlexRow>
    );
}
